"use client";
import React, { useEffect, useState } from "react";
import { userWalletData, userPoint } from "../../../../../services/billing";
import { useNavigate } from "react-router-dom";

const WalletPointsCard = () => {
  const [wallet, setWallet] = useState(null);
  const [points, setPoints] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const [walletRes, pointsRes] = await Promise.all([
        userWalletData(),
        userPoint(),
      ]);

      setWallet(walletRes?.data?.data?.wallet);
      setPoints(pointsRes?.data?.data);
    };

    fetchData();
  }, []);

  // POINTS
  const getPointStatus = (val = 0) => {
    if (val > 500) return "good";
    if (val > 200) return "medium";
    return "low";
  };

  // WALLET
  const getWalletStatus = (val = 0) => {
    if (val > "₹3000") return "good";
    if (val > "₹1000") return "medium";
    return "low";
  };
  const getPointStatusLabel = (pointsData) => {
    if (pointsData?.is_exhausted) {
      return "Exhausted";
    }
    if (pointsData?.is_low) {
      return "Low Threshold";
    }
    if ((pointsData?.balance || 0) > 1000) {
      return "Well Stocked";
    }
    return "Refill Recommended";
  };
  const getWalletStatusLabel = (walletData) => {
    
    if (!walletData || walletData === "₹0") {
      return "Empty Wallet";
    }
    if (walletData <= "₹1000") {
      return "Low Threshold";
    }
    if (walletData <= "₹2000") {
      return "Refill Recommended";
    }
    return "Well Funded";
  };

  const formatCurrencyWithoutDecimal = (amount) => {
  if (!amount) return "₹0";

  return Number(
    amount.toString().replace(/[₹,]/g, "")
  ).toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
  
  return (
    <div className="wallet-container w-100">
      {/* POINTS */}
      <div
        className="wallet-row-modern clickable-row"
        onClick={() => navigate("/billing-section/points")}
      >
        <div className="wallet-main-row">
          <div className="left">
            <div className="icon-box points">
              <i className="bi bi-star-fill"></i>
            </div>
            <div className="value-row">
              <span className="value">{Number(points?.balance || 0).toLocaleString("en-IN")}</span>
              <span className="unit">PTS</span>
            </div>
          </div>

          <div className="right-actions">
            {/* Dynamic icon: cart-plus = no points, eye = has points */}
            <div
              className="info-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/billing-section/points");
              }}
            >
              <div className={`info-circle info-circle--view`}>
                <i className={`bi bi-eye`}></i>
              </div>
              <div className="info-tooltip">{"View Points"}</div>
            </div>
          </div>
        </div>

        <div className={`sub-label ${getPointStatus(points?.balance)}`}>
          {getPointStatusLabel(points)}
        </div>
      </div>

      {/* DIVIDER */}
      <div className="divider"></div>

      {/* WALLET */}
      <div
        className="wallet-row-modern clickable-row"
        onClick={() => navigate("/billing-section/wallet")}
      >
        <div className="wallet-main-row">
          <div className="left">
            <div className="icon-box wallet">
              <i className="bi bi-wallet2 icon wallet-icon"></i>
            </div>
            <div className="value-row">
              <span className="value">{formatCurrencyWithoutDecimal(wallet?.balance) || 0}</span>
            </div>
          </div>

          <div className="right-actions">
            {/* Dynamic icon: plus-circle = no wallet, eye = has wallet */}
            <div
              className="info-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/billing-section/wallet");
              }}
            >
              <div className={`info-circle info-circle--view`}>
                <i className={`bi bi-eye`}></i>
              </div>
              <div className="info-tooltip">{"View Wallet"}</div>
            </div>
          </div>
        </div>

        <div className={`sub-label ${getWalletStatus(wallet?.balance)}`}>
          {getWalletStatusLabel(wallet?.balance)}
        </div>
      </div>
    </div>
  );
};

export default WalletPointsCard;
